"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: (0, _extends2.default)({}, theme.typography.defaultText, {
      color: theme.colors.text.black,
      borderRadius: '50%',
      overflow: 'hidden',
      '& > img': {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        textAlign: 'center'
      }
    }),
    small: {
      height: '20px',
      width: '20px'
    },
    medium: {
      height: '25px',
      width: '25px'
    },
    large: {
      height: '30px',
      width: '30px'
    },
    big: {
      height: '32px',
      width: '32px'
    },
    huge: {
      height: '64px',
      width: '64px'
    }
  };
};

exports.default = _default;